/** Sample data for the no-accounts-yet preview on Client Reporting. */

export const CLIENT_REPORTING_DEMO_SERIES = 'Demo Account';

function buildDemoEquityCurve() {
  const start = new Date();
  start.setMonth(start.getMonth() - 6);
  const points = [];
  let value = 48000;
  for (let i = 0; i < 130; i += 1) {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    const iso = d.toISOString().slice(0, 10);
    const drift = 28 + Math.sin(i / 11) * 180 + Math.cos(i / 5) * 90;
    value = Math.max(46500, value + drift);
    points.push({ date: iso, [CLIENT_REPORTING_DEMO_SERIES]: Math.round(value) });
  }
  return points;
}

export const CLIENT_REPORTING_DEMO_CHART = buildDemoEquityCurve();

export const CLIENT_REPORTING_DEMO_SUMMARY = {
  gain: { total: 4.2 },
  equity: {
    total: 51250,
    investment: 50000,
    holdings: 18420,
    cash: 32830,
  },
  profit: { total: 1250 },
};

export const CLIENT_REPORTING_DEMO_SPARKLINE = CLIENT_REPORTING_DEMO_CHART.map(
  (point) => point[CLIENT_REPORTING_DEMO_SERIES],
);

export const CLIENT_REPORTING_DEMO_SPARKLINE_DATES = CLIENT_REPORTING_DEMO_CHART.map(
  (point) => point.date,
);

/** Sample closed trades for the Recent Trades demo preview. */
export const CLIENT_REPORTING_DEMO_TRADES = [
  { exitDate: '2026-09-08', symbol: 'NVDA', side: 'Buy', quantity: 31, profit: -218.88 },
  { exitDate: '2026-09-08', symbol: 'AAPL', side: 'Buy', quantity: 23, profit: -208.49 },
  { exitDate: '2026-09-04', symbol: 'TSLA', side: 'Buy', quantity: 20, profit: -546.2 },
  { exitDate: '2026-09-03', symbol: 'PLTR', side: 'Short', quantity: 45, profit: -212.72 },
  { exitDate: '2026-09-01', symbol: 'AAPL', side: 'Buy', quantity: 24, profit: 250.56 },
  { exitDate: '2026-09-01', symbol: 'AMZN', side: 'Buy', quantity: 29, profit: -214.04 },
];
